<template>
  <v-container>
    <div style="text-align: -webkit-right" >
      <v-btn color="primary" class="modify-round-btn" @click="sheet = !sheet" fixed bottom right fab>
        <v-icon>tune</v-icon>
      </v-btn>
      <v-badge v-if="getTotalFiltros !== 0" overlap bordered color="info" style="position:fixed; bottom:50px; right: 20px; z-index: 9">
        <template v-slot:badge>
          <span>{{getTotalFiltros}}</span>
        </template>
      </v-badge>
    </div>

    <v-bottom-sheet v-model="sheet">
      <v-form v-model="valid" id="form" ref="form" :style="dialogInmuebles ? 'display: none' : ''">
      <v-sheet class="text-center activate-overflow altura">
        <v-layout xs12 sm12 md12 lg12 justify-end px-3 pt-3 pb-1>
          <v-btn small text icon @click="sheet = !sheet" right>
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>

        <v-layout wrap pb-1 pl-5 pr-5>
          <v-flex xs12 sm12 md3 lg3 pl-3 pr-3>
            <v-text-field v-model="storeFilters.referencia" id="referencia" clearable
              :label="$t('sectionInformes.filtros.numIncidencia')"
              :rules="[rules.integerNumber0]"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md3 lg3 pl-3 pr-3>
            <v-autocomplete
              v-model="storeFilters.propertyDevelopment"
              id="propertyDevelopment"
              :no-data-text="$t('sinDatos')"
              :items="promocionesProveedor"
              :label="$t('sectionInformes.filtros.promocion')"
              item-value="id"
              item-text="name"
              multiple
              @change="vaciarInmueble()"
              @click:clear="$nextTick(() => storeFilters.propertyDevelopment = [])"
              >
                      <template v-slot:selection="data">
                        {{ pintarPromocion(data) }}
                      </template>
                      <template v-slot:item="data">
                        {{ pintarPromocion(data) }}
                      </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm12 md3 lg3 pl-1 pr-1>
            <v-btn color="primary" class="mr-1 pa-1" @click="borrarFiltros()">{{ $t('sectionInformes.filtros.borrar') }}</v-btn>
            <v-btn color="primary" class="pa-1" @click="launchFilters()">{{ $t('sectionInformes.filtros.aplicar') }}</v-btn>
          </v-flex>
        </v-layout>
        <v-layout wrap pb-1 pl-5 pr-5>

          <v-flex xs12 sm12 md3 lg3 pl-3 pr-3>
            <v-autocomplete :no-data-text="$t('sinDatos')" :items="getEstados" item-text="name" clearable multiple sort-by="code"
              @click:clear="$nextTick(() => storeFilters.status = [])"
              item-value="id" :label="$t('sectionInformes.filtros.estado')" v-model="storeFilters.status" id="status" ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm12 md3 lg3 pl-3 pr-3>
            <v-autocomplete :no-data-text="$t('sinDatos')" :items="urgencias" item-text="name" clearable multiple sort-by="code"
            @click:clear="$nextTick(() => storeFilters.severityId = [])"
              item-value="id" :label="$t('sectionInformes.filtros.urgencia')" v-model="storeFilters.severityId" id="severityId"></v-autocomplete>
          </v-flex>
          <v-flex xs12 md3 lg3 pl-3 pr-3>
            <v-autocomplete :no-data-text="$t('sinDatos')" v-model="storeFilters.profession" id="profession" :items="oficios"
              item-text="name" item-value="id"
              @click:clear="$nextTick(() => storeFilters.profession = [])"
              clearable multiple :label="$t('sectionInformes.filtros.oficio')" sort-by="code"></v-autocomplete>
          </v-flex>
          <v-flex xs12 md3 lg3 pl-3 pr-3>
            <v-tooltip bottom :disabled="!disabledSuboficiosInciPref">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-autocomplete :no-data-text="$t('sinDatos')" :items="subOficios" item-text="name" item-value="id"
                    :disabled="disabledSuboficiosInciPref"
                    v-model="storeFilters.subprofession" id="subprofession" clearable multiple
                    @click:clear="$nextTick(() => storeFilters.subprofession = [])"
                    :label="$t('sectionInformes.filtros.suboficio')" sort-by="code"
                  />
                </div>
              </template>
              <span>Para seleccionar suboficios seleccione solo un oficio</span>
            </v-tooltip>
          </v-flex>
        </v-layout>

        <v-layout wrap  pl-5 pr-5>
          <v-flex xs12 md3 lg3 pl-3 pr-3>
            <v-autocomplete :no-data-text="$t('sinDatos')" :items="roomPropTypes" clearable multiple sort-by="code"
              @click:clear="$nextTick(() => storeFilters.location = [])"
              v-model="storeFilters.location" id="location" item-text="name" :label="$t('sectionInformes.filtros.localizacion')"></v-autocomplete>
          </v-flex>
        </v-layout>

        <v-layout wrap pl-5 justify-center>
          <v-flex xs12 sm12 md2 lg2 pl-3 pr-3>
            <v-menu v-model="menuFinPrevisto" id="menuFinPrevisto" :close-on-content-click="false"
              :nudge-right="40" :nudge-top="450" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-combobox v-model="finPrevistoFormated" id="finPrevistoFormated" multiple
                  clearable
                  @click:clear="$nextTick(() => storeFilters.finishDate = [])"
                  :label="$t('sectionInformes.filtros.fechaFinPrevista')"
                  :rules="[rules.length02]"
                  chips small-chips prepend-icon="event" v-on="on"></v-combobox>
              </template>
              <v-date-picker v-model="storeFilters.finishDate" id="finishDate" multiple range
                @input="checkCloseFinPrevisto(storeFilters.finishDate.length)"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm12 md2 lg2 pl-3 pr-3>
            <v-menu v-model="menuFinReal" id="menuFinReal" :close-on-content-click="false"
              :nudge-right="40" :nudge-top="450" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-combobox v-model="finRealFormated" id="finRealFormated" multiple chips small-chips
                  clearable
                  @click:clear="$nextTick(() => storeFilters.realFinishDate = [])"
                  :label="$t('sectionInformes.filtros.fechaFinReal')"
                  :rules="[rules.length02]"
                  prepend-icon="event" v-on="on"></v-combobox>
              </template>
              <v-date-picker v-model="storeFilters.realFinishDate" id="realFinishDate" multiple range
                @input="checkCloseFinReal(storeFilters.realFinishDate.length)"></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs12 sm12 md2 lg2 pl-3 pr-3>
            <v-menu v-model="menuApertura" id="menuApertura" :close-on-content-click="false"
              :nudge-right="40" :nudge-top="450" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-combobox v-model="aperturaIncidenciaFormated" id="aperturaIncidenciaFormated" multiple chips small-chips
                  clearable
                  @click:clear="$nextTick(() => storeFilters.openDate = [])"
                  :label="$t('sectionInformes.filtros.fechaApertura')"
                  :rules="[rules.length02]"
                  prepend-icon="event" v-on="on"></v-combobox>
              </template>
              <v-date-picker v-model="storeFilters.openDate" id="openDate" multiple range
                @input="checkCloseFechaApertura(storeFilters.openDate.length)"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm12 md2 lg2 pl-3 pr-3>
            <v-menu v-model="menuFechaAviso" id="menuFechaAviso" :close-on-content-click="false"
              :nudge-right="40" :nudge-top="450" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-combobox v-model="fechaAvisoFormated" id="fechaAvisoFormated" multiple chips small-chips
                  clearable
                  @click:clear="$nextTick(() => storeFilters.notificationDate = [])"
                  :label="$t('sectionInformes.filtros.fechaAviso')"
                  :rules="[rules.length02]"
                  prepend-icon="event" v-on="on"></v-combobox>
              </template>
              <v-date-picker v-model="storeFilters.notificationDate" id="notificationDate" multiple range
                @input="checkCloseFechaAviso(storeFilters.notificationDate.length)"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-sheet>
      </v-form>
    </v-bottom-sheet>
    <v-fade-transition>
      <custom-dialog
        v-if="dialogInmuebles"
        v-model="dialogInmuebles"
        id="dialogInmuebles"
        @aceptar="dialogInmuebles = $event"
      >
        <PopUpSeleccionarInmuebles
          @selected="storeFilters.selectedProperties = $event"
          @empezar="empezarEspeciales = $event"
          :yaSeleccionado="storeFilters.selectedProperties"
          :promoId="storeFilters.propertyDevelopment"
          :multiple="true"
          :especiales="empezarEspeciales"
        />
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog
        v-if="mostrarSeleccionarPromociones"
        v-model="mostrarSeleccionarPromociones"
        id="mostrarSeleccionarPromociones"
      >
        <PopUpSeleccionarPromociones
          :multiple="true"
          @selected="popupSeleccionarPromociones($event)"
        />
      </custom-dialog>
    </v-fade-transition>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import InmueblesPorIncidencia from './inmueblesPorIncidencia'
import moment from 'moment'
import PopUpSeleccionarInmuebles from './PopUpSeleccionarInmuebles'
import rulesMixin from '@/components/generic/rules.js'
import PopUpSeleccionarPromociones from './maestros/PopUpSeleccionarPromociones'

export default {
  mixins: [rulesMixin],
  components: {
    // InmueblesPorIncidencia
    PopUpSeleccionarInmuebles,
    PopUpSeleccionarPromociones
  },
  props: {
    filtros: {
      type: Object,
      required: true
    }
  },
  name: 'Filters',
  data () {
    return {
      valid: false,
      storeFilters: null,
      codigoTipoSolicitudesValue: null,
      dialogInmuebles: false,
      empezarEspeciales: false,
      sheet: false,
      finPrevisto: [],
      menuFinReal: false,
      menuFechaVisita: false,
      menuFinPrevisto: false,
      menuApertura: false,
      menuFechaCierre: false,
      menuFechaAviso: false,
      menuFechaRevisada: false,
      totalFiltros: 0,
      mostrarSeleccionarPromociones: false,
      origenItems: [
        {
          id: '1',
          name: 'Portal del Cliente'
        },
        {
          id: '2',
          name: 'WEB'
        },
        {
          id: '3',
          name: 'APP'
        },
        {
          id: '4',
          name: 'Prinex'
        }
      ],
      promocionesProveedor: [],
      promocionesProveedorNombreCompleto: []
    }
  },
  promocionesProveedorNombreCompleto () {
    if (this.promocionesProveedor) {
      return this.promocionesProveedor.map(x => {
        return {
          ...x,
          nombreCompleto: x.code + ' - ' + x.name
        }
      })
    }
  },
  created () {
    this.storeFilters = Object.assign({}, this.filtros)
    this.obtenerPromocionesProveedor()
      .then(result => {
        if(result.data.data.length > 0) {
          this.promocionesProveedor = result.data.data
        }
      })
  },
  computed: {
    ...mapGetters({
      tiposSolicitudes: 'configuracion/getTiposSolicitud',
      // getterUrgencias: 'incidencias/getUrgencias',
      idubapi: 'login/idubapi',
      rolProveedor: 'login/rolProveedor'
    }),
    responsables () {
      if (this.$store.state.incidencias.responsables) {
        return this.$store.state.incidencias.responsables
      }
      return []
    },
    inmueblesSeleccionadosConId: {
      get () {
        return this.storeFilters.selectedProperties.map(x => {
          return {
            ...x,
            inmuebleDesc: x.uhedit + ' - ' + x.direccion,
            id: x.inmuebleId != null ? x.inmuebleId: x.inmuebleEspecialId
          }
        })
      },
      set (value) {
        return value
      }
    },
    disabledInmuebles () {
      return this.storeFilters.propertyDevelopment?.length == 0 || this.storeFilters.propertyDevelopment?.length > 1
    },
    disabledSuboficiosInciPref () {
      return this.storeFilters.profession?.length == 0 || this.storeFilters.profession?.length > 1
    },
    getTotalFiltros () {
      let filtros = this.filtros
      let totalFiltros = 0
      let excluirFiltros = [
        'closeDate',
        'finishDate',
        'notificationDate',
        'openDate',
        'realFinishDate',
        'fechaRevisada'
      ]

      Object.keys(filtros).forEach(function(key){
        if (excluirFiltros.includes(key) === false) {
          let filtro = filtros[key]
          if(key === 'actorId') return
          let isObject = (typeof filtro === 'object' && filtro !== null)

          if(!isObject) {
            if(filtro != null && filtro != false && key != 'lastPage') {
              console.log('suma filtro', key)
              totalFiltros++
            }
          } else {
            if(filtro.length > 0) {
              console.log('suma filtro', key)
              totalFiltros++
            }
          }
        }
      })

      return totalFiltros
    },
    getEstados () {
      if (this.$store.state.incidencias.estados && this.$store.state.incidencias.estados.length > 0) {
        let estadosAux = []
        // let filterByEstado = (this.$store.state.configuracion.configuracion.configVistoBuenoCliente === false)?true:false;
        this.$store.state.incidencias.estados.forEach(estado => {
          //if((filterByEstado == false) || ((filterByEstado == true) && (estado.code != 41))) {
            estadosAux.push(estado)
          //}
        })
        return estadosAux
      }
      return []
    },
    tiposVisita () {
      if (this.$store.state.incidencias.tipoVisita) {
        return this.$store.state.incidencias.tipoVisita
      }
      return []
    },
    promociones () {
      if (this.$store.state.incidencias.promociones) {
        return this.$store.state.incidencias.promociones.map(x => {
          return {
            ...x,
            nombreCompleto: (this.idubapi.motor === 'SQLSERVER') ? x.name + ' - ' + x.code : x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    oficios () {
      if (this.$store.state.incidencias.oficios) {
        return this.$store.state.incidencias.oficios
      }
      return []
    },
    selectedOficioId () {
      if (this.$store.state.incidencias.selectedOficioId) {
        return this.$store.state.incidencias.selectedOficioId
      }
      return null
    },
    subOficios () {
      if (this.$store.state.incidencias.suboficios) {
        return this.$store.state.incidencias.suboficios
      }
      return []
    },
    incidenciasPred () {
      if (this.$store.state.incidencias.incidenciasPred) {
        return this.$store.state.incidencias.incidenciasPred
      }
      return []
    },
    providers () {
      if (this.$store.state.incidencias.providers) {
        return this.$store.state.incidencias.providers.map(x => {
          return {
            ...x,
            nombreCompleto: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    providersByPromoAndProf () {
      if (this.$store.state.incidencias.providersByPropDevAndProf) {
        return this.$store.state.incidencias.providersByPropDevAndProf.map(x => {
          return {
            ...x,
            nombreCompleto: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    reclamaciones () {
      if (this.$store.state.incidencias.complaintTypes) {
        return this.$store.state.incidencias.complaintTypes
      }
      return []
    },
    inciPredByProf () {
      if (this.$store.state.incidencias.predefInciByProf) {
        return this.$store.state.incidencias.predefInciByProf
      }
      return []
    },
    orderTypes () {
      if (this.$store.state.incidencias.orderTypes) {
        return this.$store.state.incidencias.orderTypes
      }
      return []
    },
    roomPropTypes () {
      if (this.$store.state.incidencias.roomPropTypes) {
        return this.$store.state.incidencias.roomPropTypes
      }
      return []
    },
    urgencias () {
      if (this.$store.state.incidencias.urgencias) {
        return this.$store.state.incidencias.urgencias
      }
      return []
    },
    visitDateFormated () {
      if (!this.storeFilters.visitFecha) {
        return null
      } else {
        return moment(this.storeFilters.visitFecha, 'YYYY-MM-DD').format('DD/MM/YYYY')
      }
    },
    finPrevistoFormated: {
      get () {
        let arrayCambiados = []
        this.storeFilters.finishDate.forEach(x => {
          arrayCambiados.push(moment(x, 'YYYY-MM-DD').format('DD/MM/YYYY'))
        })
        return arrayCambiados
      },
      set (value) {
        return value
      }
    },
    finRealFormated: {
      get () {
        let arrayCambiados = []
        this.storeFilters.realFinishDate.forEach(x => {
          arrayCambiados.push(moment(x, 'YYYY-MM-DD').format('DD/MM/YYYY'))
        })
        return arrayCambiados
      },
      set (value) {
        return value
      }
    },
    aperturaIncidenciaFormated: {
      get () {
        let arrayCambiados = []
        this.storeFilters.openDate.forEach(x => {
          arrayCambiados.push(moment(x, 'YYYY-MM-DD').format('DD/MM/YYYY'))
        })
        return arrayCambiados
      },
      set (value) {
        return value
      }
    },
    fechaAvisoFormated: {
      get () {
        let arrayCambiados = []
        this.storeFilters.notificationDate.forEach(x => {
          arrayCambiados.push(moment(x, 'YYYY-MM-DD').format('DD/MM/YYYY'))
        })
        return arrayCambiados
      },
      set (value) {
        return value
      }
    },
    fechaCierreFormated: {
      get () {
        let arrayCambiados = []
        this.storeFilters.closeDate.forEach(x => {
          arrayCambiados.push(moment(x, 'YYYY-MM-DD').format('DD/MM/YYYY'))
        })
        return arrayCambiados
      },
      set (value) {
        return value
      }
    },
    fechaRevisadaFormated: {
      get () {
        let arrayCambiados = []
        this.storeFilters.fechaRevisada.forEach(x => {
          arrayCambiados.push(moment(x, 'YYYY-MM-DD').format('DD/MM/YYYY'))
        })
        return arrayCambiados
      },
      set (value) {
        return value
      }
    }
  },
  methods: {
    openDialogInmuebles () {
      if (!this.disabledInmuebles) {
        this.$store.commit('incidencias/setPropertiesByStringAndPropDevId', [])
        this.dialogInmuebles = true
      }
    },
    getSubOficios () {
      if (this.storeFilters.profession.length != 1) {
        this.storeFilters.subprofession = []
        this.storeFilters.predefinedIncidence = []
      }
      this.getSuboficios(this.storeFilters.profession.length == 1 ? this.storeFilters.profession[0] : null)
    },
    ...mapActions({
      addAlert: 'alerts/add',
      getStatusTypes: 'incidencias/getStatusTypes',
      getVisitTypes: 'incidencias/getVisitTypes',
      getPropertiesDevelopment: 'incidencias/getPropertiesDevelopment',
      getOficios: 'incidencias/getOficios',
      getSuboficios: 'incidencias/getSuboficios',
      getComplaintTypes: 'incidencias/getComplaintTypes',
      getPredefinedIncidencesByProfession: 'incidencias/getPredefinedIncidencesByProfession',
      getPredefinedIncidences: 'incidences/getPredefinedIncidences',
      getOrderTypes: 'incidencias/getOrderTypes',
      getProviders: 'incidencias/getProviders',
      getProvidersByPropertyDevAndProfession: 'incidencias/getProvidersByPropertyDevAndProfession',
      getPropertiesByStringAndPropertyDevId: 'incidencias/getPropertiesByStringAndPropertyDevId',
      getIncidencias: 'incidencias/getIncidencias',
      getUrgencias: 'incidencias/getUrgencias',
      getAllRoomPropertyTypes: 'incidencias/getAllRoomPropertyTypes',
      getResponsables: 'incidencias/getResponsables',
      setFiltros: 'incidencias/setFiltros',
      obtenerPromocionesProveedor: 'incidencias/obtenerPromocionesProveedor',
      obtenerInmueblesProveedor: 'incidencias/obtenerInmueblesProveedor'
    }),
    launchFilters () {

      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: 'Por favor, revise los campos marcados en rojo', color: 'error'})
        return
      }

      this.storeFilters.openDate1 = this.storeFilters.openDate.length > 0 ? this.storeFilters.openDate[0] : null
      this.storeFilters.openDate2 = this.storeFilters.openDate.length > 0 ? this.storeFilters.openDate[1] : null
      this.storeFilters.finishDate1 = this.storeFilters.finishDate.length > 0 ? this.storeFilters.finishDate[0] : null
      this.storeFilters.finishDate2 = this.storeFilters.finishDate.length > 0 ? this.storeFilters.finishDate[1] : null
      this.storeFilters.realFinishDate1 = this.storeFilters.realFinishDate.length > 0 ? this.storeFilters.realFinishDate[0] : null
      this.storeFilters.realFinishDate2 = this.storeFilters.realFinishDate.length > 0 ? this.storeFilters.realFinishDate[1] : null
      this.storeFilters.notificationDate1 = this.storeFilters.notificationDate.length > 0 ? this.storeFilters.notificationDate[0] : null
      this.storeFilters.notificationDate2 = this.storeFilters.notificationDate.length > 0 ? this.storeFilters.notificationDate[1] : null
      this.storeFilters.closeDate1 = this.storeFilters.closeDate.length > 0 ? this.storeFilters.closeDate[0] : null
      this.storeFilters.closeDate2 = this.storeFilters.closeDate.length > 0 ? this.storeFilters.closeDate[1] : null
      this.storeFilters.fechaRevisada1 = this.storeFilters.fechaRevisada.length > 0 ? this.storeFilters.fechaRevisada[0] : null
      this.storeFilters.fechaRevisada2 = this.storeFilters.fechaRevisada.length > 0 ? this.storeFilters.fechaRevisada[1] : null

      this.setFiltros(this.storeFilters)
      this.$emit('valoresFiltros', this.storeFilters)

      this.sheet = !this.sheet
    },
    checkCloseFinPrevisto (length) {
      if (length === 2) {
        this.menuFinPrevisto = false
      } else {
        this.menuFinPrevisto = true
      }
    },
    checkCloseFinReal (length) {
      if (length === 2) {
        this.menuFinReal = false
      } else {
        this.menuFinReal = true
      }
    },
    checkCloseFechaApertura (length) {
      if (length === 2) {
        this.menuApertura = false
      } else {
        this.menuApertura = true
      }
    },
    checkCloseFechaAviso (length) {
      if (length === 2) {
        this.menuFechaAviso = false
      } else {
        this.menuFechaAviso = true
      }
    },
    checkCloseFechaCierre (length) {
      if (length === 2) {
        this.menuFechaCierre = false
      } else {
        this.menuFechaCierre = true
      }
    },
    checkCloseFechaRevisada (length) {
      if (length === 2) {
        this.menuFechaRevisada = false
      } else {
        this.menuFechaRevisada = true
      }
    },
    popupSeleccionarPromociones (event) {
      if (event != null && event.length > 0) {
        this.storeFilters.propertyDevelopment = event.map( x => x.id)
      }
    },
    borrarFiltros () {
      // TO-DO: Mirar si hay que poder filtrar también por más de un inmueble
      // Y preguntar si esto afecta en algún otro sitio (en front sale referenciado, pero la página no está en el router)
      this.storeFilters.referencia = null
      this.storeFilters.openDate = []
      this.storeFilters.finishDate = []
      this.storeFilters.realFinishDate = []
      this.storeFilters.notificationDate = []
      this.storeFilters.closeDate = []
      this.storeFilters.fechaRevisada = []

      this.storeFilters.propertyDevelopment = []
      this.storeFilters.selectedProperties = []
      this.storeFilters.location = []
      this.storeFilters.status = []
      this.storeFilters.profession = []
      this.storeFilters.subprofession = []
      this.storeFilters.predefinedIncidence = []
      this.storeFilters.provider = []
      this.storeFilters.orderType = []
      this.storeFilters.vb = false
      this.storeFilters.complaint = []
      this.storeFilters.idIncidence = null
      this.storeFilters.openDate1 = null
      this.storeFilters.openDate2 = null
      this.storeFilters.finishDate1 = null
      this.storeFilters.finishDate2 = null
      this.storeFilters.realFinishDate1 = null
      this.storeFilters.realFinishDate2 = null
      this.storeFilters.notificationDate1 = null
      this.storeFilters.notificationDate2 = null
      this.storeFilters.closeDate1 = null
      this.storeFilters.closeDate2 = null
      this.storeFilters.fechaRevisada1 = null
      this.storeFilters.fechaRevisada2 = null
      this.storeFilters.visitFecha = null
      this.storeFilters.numVisit = null
      this.storeFilters.origen = []
      this.storeFilters.nombreCliente = null
      this.storeFilters.telefono = null
      this.storeFilters.movil = null
      this.storeFilters.email = null
      this.storeFilters.tipoVisita = []
      this.storeFilters.codigoTipoSolicitud = []
      this.storeFilters.severityId = []
      this.storeFilters.responsable = [],
      this.storeFilters.revisada = null
    },
    vaciarInmueble () {
      this.storeFilters.selectedProperties = []
    },
    pintarPromocion(item) {
      let datosPromocion = item.item
      return (this.idubapi.motor === 'SQLSERVER') ? datosPromocion.name + ' - ' + datosPromocion.code : datosPromocion.code + ' - ' + datosPromocion.name
      // return (datosPromocion.idSociedad) ? datosPromocion.name + ' - ' + datosPromocion.code : datosPromocion.code + ' - ' + datosPromocion.name
    }
  },
  mounted () {
    this.getStatusTypes()
    this.getVisitTypes()
    this.getPropertiesDevelopment()
    this.getOficios()
    this.getComplaintTypes()
    this.getOrderTypes()
    this.getProviders()
    this.getAllRoomPropertyTypes()
    this.getUrgencias()
    this.getResponsables()
  },
  watch: {
    filtros () {
      this.storeFilters = Object.assign({}, this.filtros)
    },
    'storeFilters.profession': function () {
      if(this.storeFilters.profession.length == 1) {
        this.getSuboficios(this.storeFilters.profession[0])
        this.getPredefinedIncidencesByProfession({professionId: this.storeFilters.profession[0], subProfessionId: null})

      } let items = {
        professionId: !this.storeFilters.profession[0] || this.storeFilters.profession === '' ? null : this.storeFilters.profession[0],
        propertyDevelopmentId: ( this.storeFilters.propertyDevelopment.length > 0 ?  this.storeFilters.propertyDevelopment[0] : '')
      }
      this.getProvidersByPropertyDevAndProfession(items)
        /* this.disabledSuboficiosInciPref = true */

    },
    'storeFilters.subprofession': function () {
      if(this.storeFilters.subprofession.length == 1) {
        this.getPredefinedIncidencesByProfession({professionId: this.storeFilters.profession[0], subProfessionId: this.storeFilters.subprofession[0]})
      }
    },
    'storeFilters.propertyDevelopment': function () {
      let items = {
        professionId: !this.storeFilters.profession[0] ? null : this.storeFilters.profession[0],
        propertyDevelopmentId: ( this.storeFilters.propertyDevelopment.length > 0 ?  this.storeFilters.propertyDevelopment[0] : '')
      }
      this.getProvidersByPropertyDevAndProfession(items)
      this.obtenerInmueblesProveedor({
        propertyDevelopmentId: ( this.storeFilters.propertyDevelopment.length > 0 ?  this.storeFilters.propertyDevelopment : [])
      })
    }
  }
}
</script>

<style scoped>

.v-btn--fab.v-size--default.v-btn--absolute.v-btn--top {
  top: 65px;
}
.activate-overflow {
  overflow-y: scroll;
}

#filters-divider {
  margin-left: .5em;
}
.modify-round-btn {
  height: 45px !important;
  width: 45px !important;
}
.v-btn--absolute.v-btn--bottom, .v-btn--fixed.v-btn--bottom {
  bottom: 10px;
}

@media (max-width: 1366px) {
  .altura {
    height: 60vh;
  }
}

@media (min-width: 1367px) and (max-width: 1600px) {
  .altura {
    height: 50vh;
  }
}

@media (min-width: 1601px) {
  .altura {
    height: 40vh;
  }
}
</style>
